// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_listFav__Lgeua {
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.styles_itemsList__iyDC4 {
  height: 400px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Exchange/pageContent/inputBlock/inputCurrency/modal/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kDAAA;AADF;;AAIA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADF","sourcesContent":["@import '../../../../../../assets/styles/variables/colors';\n\n.listFav {\n  padding-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 1px solid $white-5;\n}\n\n.itemsList {\n  height: 400px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listFav": `styles_listFav__Lgeua`,
	"itemsList": `styles_itemsList__iyDC4`
};
export default ___CSS_LOADER_EXPORT___;
